"use strict";

// =====================================================
// BONIFICACIÓN POR PRODUCCIÓN
//
// Archivo:
// src/fronend/Ingresos/produccion/produccion.js
//
// =====================================================


// =====================================================
// VARIABLES
// =====================================================

let registrosproduccion = [];

let moduloProduccionInicializado = false;

let tbodyProduccion = null;
let buscarProduccion = null;
let btnLimpiarBusqueda = null;


// =====================================================
// INICIALIZAR MÓDULO
// =====================================================

function inicializarProduccion() {

    if (moduloProduccionInicializado) {
        return;
    }

    moduloProduccionInicializado = true;


    tbodyProduccion =
        document.getElementById(
            "tbodyProduccion"
        );


    buscarProduccion =
        document.getElementById(
            "buscarProduccion"
        );


    btnLimpiarBusqueda =
        document.getElementById(
            "btnLimpiarBusqueda"
        );


    // =================================================
    // BUSCADOR
    // =================================================

    if (buscarProduccion) {

        buscarProduccion.addEventListener(
            "input",
            function () {

                filtrarProduccion(
                    this.value
                );

            }
        );

    }


    // =================================================
    // LIMPIAR BÚSQUEDA
    // =================================================

    if (btnLimpiarBusqueda) {

        btnLimpiarBusqueda.addEventListener(
            "click",
            function () {

                if (buscarProduccion) {

                    buscarProduccion.value = "";

                }


                renderizarProduccion(
                    registrosproduccion
                );


                actualizarResumenProduccion(
                    registrosproduccion
                );

            }
        );

    }


    // =================================================
    // EVENTO BONIFICACIÓN POR PRODUCCIÓN
    // =================================================

    const inputBonificacionProduccion =
        document.getElementById(
            "bonificacionProduccion"
        );


    if (inputBonificacionProduccion) {

        inputBonificacionProduccion.addEventListener(
            "input",
            function () {

                calcularTotalAPagarProduccion();

            }
        );


        inputBonificacionProduccion.addEventListener(
            "change",
            function () {

                calcularTotalAPagarProduccion();

            }
        );

    }


    // =================================================
    // LISTAR
    // =================================================

    listarProduccion();

}


// =====================================================
// CALCULAR TOTAL A PAGAR POR PRODUCCIÓN
// =====================================================
//
// OPERACIÓN:
//
// PAGOTOTALPORBONIFICACION
// +
// BONIFICACIONPORPRODUCCION
// =
// TOTALAPAGARPORPRODUCCIONBONIFICACION
//
// =====================================================

function calcularTotalAPagarProduccion() {

    const inputPagoTotalBonificacion =
        document.getElementById(
            "pagoTotalBonificacion"
        );


    const inputBonificacionProduccion =
        document.getElementById(
            "bonificacionProduccion"
        );


    const inputTotalAPagar =
        document.getElementById(
            "totalAPagarPorProduccion"
        );


    if (!inputPagoTotalBonificacion) {

        console.warn(
            "No existe #pagoTotalBonificacion"
        );

        return;

    }


    if (!inputBonificacionProduccion) {

        console.warn(
            "No existe #bonificacionProduccion"
        );

        return;

    }


    if (!inputTotalAPagar) {

        console.warn(
            "No existe #totalAPagarPorProduccion"
        );

        return;

    }


    // =================================================
    // OBTENER VALORES
    // =================================================

    const pagoTotalBonificacion =
        convertirMonedaANumero(
            inputPagoTotalBonificacion.value
        );


    const bonificacionProduccion =
        convertirMonedaANumero(
            inputBonificacionProduccion.value
        );


    // =================================================
    // OPERACIÓN
    // =================================================

    const totalAPagar =
        pagoTotalBonificacion +
        bonificacionProduccion;


    // =================================================
    // MOSTRAR TOTAL
    // =================================================

    inputTotalAPagar.value =
        formatearMoneda(
            totalAPagar
        );


    // =================================================
    // ACTUALIZAR RESUMEN
    // =================================================

    const resumenTotal =
        document.getElementById(
            "resumenTotal"
        );


    if (resumenTotal) {

        resumenTotal.textContent =
            formatearMoneda(
                totalAPagar
            );

    }


    // =================================================
    // ACTUALIZAR REGISTRO EN MEMORIA
    // =================================================

    if (
        window.registroProduccionSeleccionado
    ) {

        window.registroProduccionSeleccionado
            .BONIFICACIONPORPRODUCCION =
            bonificacionProduccion;


        window.registroProduccionSeleccionado
            .TOTALAPAGARPORPRODUCCIONBONIFICACION =
            totalAPagar;

    }


    console.log(
        "Cálculo automático:",
        {
            pagoTotalBonificacion:
                pagoTotalBonificacion,

            bonificacionProduccion:
                bonificacionProduccion,

            totalAPagar:
                totalAPagar
        }
    );

}


// =====================================================
// LISTAR PRODUCCIÓN
// =====================================================

async function listarProduccion() {

    if (!tbodyProduccion) {

        tbodyProduccion =
            document.getElementById(
                "tbodyProduccion"
            );

    }


    if (tbodyProduccion) {

        tbodyProduccion.innerHTML = `

            <tr>

                <td
                    colspan="24"
                    class="text-center py-4">

                    <div
                        class="spinner-border text-success"
                        role="status">

                        <span class="visually-hidden">
                            Cargando...
                        </span>

                    </div>

                    <div class="mt-2 text-muted">

                        Cargando información...

                    </div>

                </td>

            </tr>

        `;

    }


    try {

        const respuesta =
            await fetch(
                "/produccion/listar",
                {
                    method: "GET",

                    headers: {
                        "Accept":
                            "application/json"
                    }
                }
            );


        if (!respuesta.ok) {

            throw new Error(
                `Error HTTP ${respuesta.status}`
            );

        }


        const resultado =
            await respuesta.json();


        if (!resultado.ok) {

            throw new Error(
                resultado.mensaje ||
                "No se pudieron obtener los datos."
            );

        }


        registrosproduccion =
            Array.isArray(
                resultado.data
            )
                ? resultado.data
                : [];


        window.registrosproduccion =
            registrosproduccion;


        renderizarProduccion(
            registrosproduccion
        );


        actualizarResumenProduccion(
            registrosproduccion
        );


    } catch (error) {

        console.error(
            "Error al listar producción:",
            error
        );


        if (tbodyProduccion) {

            tbodyProduccion.innerHTML = `

                <tr>

                    <td
                        colspan="24"
                        class="text-center text-danger py-4">

                        <i
                            class="bi bi-exclamation-triangle-fill">
                        </i>

                        <div class="mt-2">

                            Error al cargar la información

                        </div>

                        <small>

                            ${escapeHtml(
                                error.message
                            )}

                        </small>

                    </td>

                </tr>

            `;

        }

    }

}


// =====================================================
// RENDERIZAR TABLA
// =====================================================

function renderizarProduccion(
    registros
) {

    if (!tbodyProduccion) {

        tbodyProduccion =
            document.getElementById(
                "tbodyProduccion"
            );

    }


    if (!tbodyProduccion) {
        return;
    }


    if (
        !Array.isArray(registros) ||
        registros.length === 0
    ) {

        tbodyProduccion.innerHTML = `

            <tr>

                <td
                    colspan="24"
                    class="text-center text-muted py-4">

                    <i
                        class="bi bi-inbox fs-3">
                    </i>

                    <div class="mt-2">

                        No hay registros de producción.

                    </div>

                </td>

            </tr>

        `;

        return;

    }


    tbodyProduccion.innerHTML =
        registros
            .map(
                (
                    registro,
                    indice
                ) => {

                    return `

                        <tr>

                            <!-- 1 -->
                            <td class="text-center">

                                ${indice + 1}

                            </td>


                            <!-- 2 -->
                            <td class="text-center">

                                ${valor(
                                    registro.IDINGRESONO
                                )}

                            </td>


                            <!-- 3 -->
                            <td class="text-center">

                                ${formatearFecha(
                                    registro.FECHAINGRESO
                                )}

                            </td>


                            <!-- 4 -->
                            <td>

                                ${escapeHtml(
                                    registro.NOMBREEMPLEADO
                                )}

                            </td>


                            <!-- 5 -->
                            <td>

                                ${escapeHtml(
                                    registro.DPI
                                )}

                            </td>


                            <!-- 6 -->
                            <td>

                                ${escapeHtml(
                                    registro.NOMBREPUESTO
                                )}

                            </td>


                            <!-- 7 -->
                            <td>

                                ${escapeHtml(
                                    registro.DIRECCION
                                )}

                            </td>


                            <!-- 8 -->
                            <td class="text-end">

                                ${formatearMoneda(
                                    registro.SALARIOBASE
                                )}

                            </td>


                            <!-- 9 -->
                            <td class="text-center">

                                ${valor(
                                    registro.CANTIDADLABORALES
                                )}

                            </td>


                            <!-- 10 -->
                            <td class="text-center">

                                ${valor(
                                    registro.HORASESTABLECIDAS
                                )}

                            </td>


                            <!-- 11 -->
                            <td class="text-center">

                                ${valor(
                                    registro.HORASEXTRAS
                                )}

                            </td>


                            <!-- 12 -->
                            <td class="text-end">

                                ${formatearMoneda(
                                    registro.PAGOORDINARIAHREXTRA
                                )}

                            </td>


                            <!-- 13 -->
                            <td class="text-end">

                                ${formatearMoneda(
                                    registro.PAGOEXTRA
                                )}

                            </td>


                            <!-- 14 -->
                            <td class="text-end">

                                ${formatearMoneda(
                                    registro.TOTALEXTRAPAGADO
                                )}

                            </td>


                            <!-- 15 -->
                            <td class="text-center">

                                ${valor(
                                    registro.HRSDOBLES
                                )}

                            </td>


                            <!-- 16 -->
                            <td class="text-end">

                                ${formatearMoneda(
                                    registro.PAGOHRSDOBLE
                                )}

                            </td>


                            <!-- 17 -->
                            <td class="text-end">

                                ${formatearMoneda(
                                    registro.TOTALHRSDOBLES
                                )}

                            </td>


                            <!-- 18 -->
                            <td class="text-end">

                                ${formatearMoneda(
                                    registro.TOTALEXTRASYDOBLES
                                )}

                            </td>


                            <!-- 19 -->
                            <td class="text-end">

                                ${formatearMoneda(
                                    registro.BONIFICACIONDECRETO
                                )}

                            </td>


                            <!-- 20 -->
                            <td class="text-end">

                                ${formatearMoneda(
                                    registro.PAGOTOTALPORBONIFICACION
                                )}

                            </td>


                            <!-- 21 -->
                            <td class="text-end fw-bold">

                                ${formatearMoneda(
                                    registro.BONIFICACIONPORPRODUCCION
                                )}

                            </td>


                            <!-- 22 -->
                            <td class="text-end fw-bold">

                                ${formatearMoneda(
                                    registro.TOTALAPAGARPORPRODUCCIONBONIFICACION
                                )}

                            </td>


                            <!-- 23 -->
                            <td class="text-center">

                                ${badgeEstado(
                                    registro.ESTADO
                                )}

                            </td>


                            <!-- 24 -->
                            <td class="text-center">

                                <button
                                    type="button"
                                    class="btn btn-success btn-sm btn-dato-pagar"
                                    onclick="datoPagarProduccion(${numero(
                                        registro.IDINGRESONO
                                    )})"
                                    title="Dato de pagar">

                                    <i
                                        class="bi bi-cash-coin">
                                    </i>

                                    PAGAR

                                </button>

                            </td>

                        </tr>

                    `;

                }
            )
            .join("");

}


// =====================================================
// ABRIR MODAL DATO DE PAGAR
// =====================================================

function datoPagarProduccion(
    idIngreso
) {

    // =================================================
    // BUSCAR REGISTRO
    // =================================================

    const registro =
        registrosproduccion.find(
            item =>
                Number(
                    item.IDINGRESONO
                ) ===
                Number(
                    idIngreso
                )
        );


    // =================================================
    // VALIDAR
    // =================================================

    if (!registro) {

        console.error(
            "No se encontró el registro:",
            idIngreso
        );


        alert(
            "No se encontró la información del ingreso."
        );


        return;

    }


    // =================================================
    // GUARDAR REGISTRO SELECCIONADO
    // =================================================

    window.registroProduccionSeleccionado =
        registro;


    // =================================================
    // INFORMACIÓN DEL EMPLEADO
    // =================================================

    asignarValor(
        "mostrarIdEmpleado",
        registro.IDINGRESONO
    );


    asignarValor(
        "fechaIngreso",
        formatearFecha(
            registro.FECHAINGRESO
        )
    );


    asignarValor(
        "nombreEmpleado",
        registro.NOMBREEMPLEADO
    );


    asignarValor(
        "dpiEmpleado",
        registro.DPI
    );


    asignarValor(
        "puestoEmpleado",
        registro.NOMBREPUESTO
    );


    asignarValor(
        "direccionEmpleado",
        registro.DIRECCION
    );


    asignarValor(
        "estadoBonificacion",
        registro.ESTADO
    );


    // =================================================
    // INFORMACIÓN LABORAL
    // =================================================

    asignarValor(
        "salarioBase",
        formatearMoneda(
            registro.SALARIOBASE
        )
    );


    asignarValor(
        "diasLaborales",
        registro.CANTIDADLABORALES
    );


    asignarValor(
        "horasEstablecidas",
        registro.HORASESTABLECIDAS
    );


    // =================================================
    // HORAS EXTRAS
    // =================================================

    asignarValor(
        "horasExtras",
        registro.HORASEXTRAS
    );


    asignarValor(
        "pagoOrdinariaHrExtra",
        formatearMoneda(
            registro.PAGOORDINARIAHREXTRA
        )
    );


    asignarValor(
        "pagoExtra",
        formatearMoneda(
            registro.PAGOEXTRA
        )
    );


    asignarValor(
        "totalExtraPagado",
        formatearMoneda(
            registro.TOTALEXTRAPAGADO
        )
    );


    // =================================================
    // HORAS DOBLES
    // =================================================

    asignarValor(
        "hrsDobles",
        registro.HRSDOBLES
    );


    asignarValor(
        "pagoHrsDoble",
        formatearMoneda(
            registro.PAGOHRSDOBLE
        )
    );


    asignarValor(
        "totalHorasDoblesModal",
        formatearMoneda(
            registro.TOTALHRSDOBLES
        )
    );


    asignarValor(
        "totalExtrasDobles",
        formatearMoneda(
            registro.TOTALEXTRASYDOBLES
        )
    );


    // =================================================
    // BONIFICACIÓN DECRETO
    // =================================================

    asignarValor(
        "bonificacionDecreto",
        formatearMoneda(
            registro.BONIFICACIONDECRETO
        )
    );


    asignarValor(
        "pagoTotalBonificacion",
        formatearMoneda(
            registro.PAGOTOTALPORBONIFICACION
        )
    );


    // =================================================
    // BONIFICACIÓN PRODUCCIÓN
    // =================================================

    asignarValor(
        "bonificacionProduccion",
        formatearMoneda(
            registro.BONIFICACIONPORPRODUCCION
        )
    );


    asignarValor(
        "totalAPagarPorProduccion",
        formatearMoneda(
            registro.TOTALAPAGARPORPRODUCCIONBONIFICACION
        )
    );


    // =================================================
    // RESUMEN
    // =================================================

    asignarTexto(
        "resumenSalario",
        formatearMoneda(
            registro.SALARIOBASE
        )
    );


    asignarTexto(
        "resumenExtrasDobles",
        formatearMoneda(
            registro.TOTALEXTRASYDOBLES
        )
    );


    asignarTexto(
        "resumenBonificacionProduccion",
        formatearMoneda(
            registro.BONIFICACIONPORPRODUCCION
        )
    );


    asignarTexto(
        "resumenTotal",
        formatearMoneda(
            registro.TOTALAPAGARPORPRODUCCIONBONIFICACION
        )
    );


    // =================================================
    // MOSTRAR MODAL
    // =================================================

    const elementoModal =
        document.getElementById(
            "modalBonificacion"
        );


    if (!elementoModal) {

        console.error(
            "No existe el elemento #modalBonificacion"
        );


        alert(
            "No se encontró el modal de Dato de pagar."
        );


        return;

    }


    const modal =
        bootstrap.Modal.getOrCreateInstance(
            elementoModal
        );


    modal.show();


    // =================================================
    // CALCULAR TOTAL
    // =================================================

    calcularTotalAPagarProduccion();

}


// =====================================================
// PAGAR / GUARDAR BONIFICACIÓN POR PRODUCCIÓN
// =====================================================
//
// ENVÍA:
//
// POST /produccion/guardar
//
// Y EJECUTA:
//
// SP_INGRESONOMINA_BONIFICACIONPORPRODUCCION
//
// =====================================================

async function pagarProduccion() {

    // =================================================
    // OBTENER REGISTRO
    // =================================================

    const registro =
        window.registroProduccionSeleccionado;


    // =================================================
    // VALIDAR REGISTRO
    // =================================================

    if (!registro) {

        alert(
            "No hay ningún registro seleccionado para pagar."
        );

        return;

    }


    // =================================================
    // OBTENER INPUTS
    // =================================================

    const inputBonificacionProduccion =
        document.getElementById(
            "bonificacionProduccion"
        );


    const inputPagoTotalBonificacion =
        document.getElementById(
            "pagoTotalBonificacion"
        );


    const inputTotalAPagar =
        document.getElementById(
            "totalAPagarPorProduccion"
        );


    // =================================================
    // VALIDAR INPUTS
    // =================================================

    if (!inputBonificacionProduccion) {

        alert(
            "No existe el campo de bonificación por producción."
        );

        return;

    }


    if (!inputTotalAPagar) {

        alert(
            "No existe el campo de total a pagar."
        );

        return;

    }


    // =================================================
    // OBTENER VALORES
    // =================================================

    const pagoTotalBonificacion =
        convertirMonedaANumero(
            inputPagoTotalBonificacion
                ? inputPagoTotalBonificacion.value
                : 0
        );


    const bonificacionProduccion =
        convertirMonedaANumero(
            inputBonificacionProduccion.value
        );


    // =================================================
    // RECALCULAR TOTAL
    // =================================================

    const totalCalculado =
        pagoTotalBonificacion +
        bonificacionProduccion;


    // =================================================
    // MOSTRAR TOTAL
    // =================================================

    inputTotalAPagar.value =
        formatearMoneda(
            totalCalculado
        );


    const resumenTotal =
        document.getElementById(
            "resumenTotal"
        );


    if (resumenTotal) {

        resumenTotal.textContent =
            formatearMoneda(
                totalCalculado
            );

    }


    // =================================================
    // VALIDAR BONIFICACIÓN
    // =================================================

    if (
        bonificacionProduccion <= 0
    ) {

        alert(
            "Ingrese una bonificación por producción válida."
        );


        inputBonificacionProduccion.focus();


        return;

    }


    // =================================================
    // VALIDAR IDINGRESONO
    // =================================================

    const idIngresoNo =
        Number(
            registro.IDINGRESONO
        );


    if (
        !Number.isInteger(
            idIngresoNo
        ) ||
        idIngresoNo <= 0
    ) {

        alert(
            "El IDINGRESONO no es válido."
        );


        return;

    }


    // =================================================
    // CONFIRMACIÓN
    // =================================================

    const confirmar =
        confirm(

            "¿Desea realizar el pago?\n\n" +

            "Empleado: " +
            String(
                registro.NOMBREEMPLEADO ??
                ""
            ) +

            "\n\n" +

            "Bonificación por producción: " +
            formatearMoneda(
                bonificacionProduccion
            ) +

            "\n" +

            "Pago total bonificación: " +
            formatearMoneda(
                pagoTotalBonificacion
            ) +

            "\n\n" +

            "TOTAL A PAGAR: " +
            formatearMoneda(
                totalCalculado
            )

        );


    // =================================================
    // CANCELAR
    // =================================================

    if (!confirmar) {

        return;

    }


    // =================================================
    // DESHABILITAR BOTÓN
    // =================================================

    const botonPagar =
        document.querySelector(
            '[onclick="pagarProduccion()"]'
        );


    if (botonPagar) {

        botonPagar.disabled = true;

        botonPagar.dataset.textoOriginal =
            botonPagar.innerHTML;

        botonPagar.innerHTML = `

            <span
                class="spinner-border spinner-border-sm"
                role="status">
            </span>

            Guardando...

        `;

    }


    try {

        // =================================================
        // ENVIAR AL SERVIDOR
        // =================================================

        const respuesta =
            await fetch(
                "/produccion/guardar",
                {

                    method: "POST",

                    headers: {

                        "Content-Type":
                            "application/json",

                        "Accept":
                            "application/json"

                    },

                    body:
                        JSON.stringify({

                            IDINGRESONO:
                                idIngresoNo,

                            BONIFICACIONPORPRODUCCION:
                                bonificacionProduccion,

                            TOTALAPAGARPORPRODUCCIONBONIFICACION:
                                totalCalculado,

                            ESTADO:
                                "A"

                        })

                }
            );


        // =================================================
        // VALIDAR HTTP
        // =================================================

        if (!respuesta.ok) {

            throw new Error(
                `Error HTTP ${respuesta.status}`
            );

        }


        // =================================================
        // LEER RESPUESTA
        // =================================================

        const resultado =
            await respuesta.json();


        console.log(
            "Respuesta del servidor:",
            resultado
        );


        // =================================================
        // VALIDAR RESULTADO
        // =================================================

        if (!resultado.ok) {

            throw new Error(
                resultado.mensaje ||
                "No se pudo guardar la bonificación."
            );

        }


        // =================================================
        // ACTUALIZAR REGISTRO EN MEMORIA
        // =================================================

        registro.BONIFICACIONPORPRODUCCION =
            bonificacionProduccion;


        registro.TOTALAPAGARPORPRODUCCIONBONIFICACION =
            totalCalculado;


        registro.ESTADO =
            "A";


        // =================================================
        // ACTUALIZAR TABLA
        // =================================================

        renderizarProduccion(
            registrosproduccion
        );


        actualizarResumenProduccion(
            registrosproduccion
        );


        // =================================================
        // MENSAJE DE ÉXITO
        // =================================================

        alert(

            "Bonificación por producción guardada correctamente.\n\n" +

            "Empleado: " +
            registro.NOMBREEMPLEADO +

            "\nBonificación por producción: " +
            formatearMoneda(
                bonificacionProduccion
            ) +

            "\nTotal a pagar: " +
            formatearMoneda(
                totalCalculado
            )

        );


        // =================================================
        // CERRAR MODAL
        // =================================================

        const elementoModal =
            document.getElementById(
                "modalBonificacion"
            );


        if (elementoModal) {

            const modal =
                bootstrap.Modal.getInstance(
                    elementoModal
                );


            if (modal) {

                modal.hide();

            }

        }


        // =================================================
        // RECARGAR DATOS DESDE SQL SERVER
        // =================================================

        await listarProduccion();


        // =================================================
        // LIMPIAR REGISTRO SELECCIONADO
        // =================================================

        window.registroProduccionSeleccionado =
            null;


    } catch (error) {

        // =================================================
        // ERROR
        // =================================================

        console.error(
            "Error al guardar bonificación por producción:",
            error
        );


        alert(

            "No se pudo guardar la bonificación por producción.\n\n" +

            error.message

        );


    } finally {

        // =================================================
        // RESTAURAR BOTÓN
        // =================================================

        if (botonPagar) {

            botonPagar.disabled = false;


            if (
                botonPagar.dataset.textoOriginal
            ) {

                botonPagar.innerHTML =
                    botonPagar.dataset.textoOriginal;

            }

        }

    }

}


// =====================================================
// FILTRAR PRODUCCIÓN
// =====================================================

function filtrarProduccion(
    texto
) {

    const busqueda =
        String(
            texto || ""
        )
        .trim()
        .toLowerCase();


    if (!busqueda) {

        renderizarProduccion(
            registrosproduccion
        );


        actualizarResumenProduccion(
            registrosproduccion
        );


        return;

    }


    const filtrados =
        registrosproduccion.filter(
            registro => {

                const contenido = [

                    registro.IDINGRESONO,

                    registro.NOMBREEMPLEADO,

                    registro.DPI,

                    registro.NOMBREPUESTO,

                    registro.DIRECCION,

                    registro.ESTADO

                ]
                .map(
                    dato =>
                        String(
                            dato ?? ""
                        )
                        .toLowerCase()
                )
                .join(" ");


                return contenido.includes(
                    busqueda
                );

            }
        );


    renderizarProduccion(
        filtrados
    );


    actualizarResumenProduccion(
        filtrados
    );

}


// =====================================================
// RESUMEN
// =====================================================

function actualizarResumenProduccion(
    registros
) {

    const totalEmpleados =
        document.getElementById(
            "totalEmpleados"
        );


    const totalSalarios =
        document.getElementById(
            "totalSalarios"
        );


    const totalBonificacionProduccion =
        document.getElementById(
            "totalBonificacionProduccion"
        );


    const totalPagarProduccion =
        document.getElementById(
            "totalPagarProduccion"
        );


    if (totalEmpleados) {

        totalEmpleados.textContent =
            registros.length;

    }


    let sumaSalarios = 0;

    let sumaBonificacion = 0;

    let sumaTotalPagar = 0;


    registros.forEach(
        registro => {

            sumaSalarios +=
                numero(
                    registro.SALARIOBASE
                );


            sumaBonificacion +=
                numero(
                    registro.BONIFICACIONPORPRODUCCION
                );


            sumaTotalPagar +=
                numero(
                    registro.TOTALAPAGARPORPRODUCCIONBONIFICACION
                );

        }
    );


    if (totalSalarios) {

        totalSalarios.textContent =
            formatearMoneda(
                sumaSalarios
            );

    }


    if (totalBonificacionProduccion) {

        totalBonificacionProduccion.textContent =
            formatearMoneda(
                sumaBonificacion
            );

    }


    if (totalPagarProduccion) {

        totalPagarProduccion.textContent =
            formatearMoneda(
                sumaTotalPagar
            );

    }

}


// =====================================================
// ESTADO
// =====================================================

function badgeEstado(
    estado
) {

    const valorEstado =
        String(
            estado ?? ""
        )
        .trim()
        .toUpperCase();


    if (valorEstado === "A") {

        return `

            <span class="badge bg-success">

                ACTIVO

            </span>

        `;

    }


    if (valorEstado === "I") {

        return `

            <span class="badge bg-danger">

                INACTIVO

            </span>

        `;

    }


    return `

        <span class="badge bg-secondary">

            ${escapeHtml(
                valorEstado ||
                "SIN ESTADO"
            )}

        </span>

    `;

}


// =====================================================
// ASIGNAR VALOR
// =====================================================

function asignarValor(
    id,
    valorAsignar
) {

    const elemento =
        document.getElementById(
            id
        );


    if (!elemento) {

        console.warn(
            `No existe el elemento #${id}`
        );

        return;

    }


    elemento.value =
        valorAsignar ??
        "";

}


// =====================================================
// ASIGNAR TEXTO
// =====================================================

function asignarTexto(
    id,
    texto
) {

    const elemento =
        document.getElementById(
            id
        );


    if (!elemento) {

        console.warn(
            `No existe el elemento #${id}`
        );

        return;

    }


    elemento.textContent =
        texto ??
        "";

}


// =====================================================
// FORMATEAR MONEDA
// =====================================================

function formatearMoneda(
    valorMoneda
) {

    const numeroMoneda =
        numero(
            valorMoneda
        );


    return new Intl.NumberFormat(
        "es-GT",
        {
            style: "currency",
            currency: "GTQ",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }
    )
    .format(
        numeroMoneda
    );

}


// =====================================================
// FORMATEAR FECHA
// =====================================================

function formatearFecha(
    fecha
) {

    if (!fecha) {
        return "";
    }


    const fechaObjeto =
        new Date(
            fecha
        );


    if (
        Number.isNaN(
            fechaObjeto.getTime()
        )
    ) {

        return String(
            fecha
        );

    }


    return fechaObjeto.toLocaleDateString(
        "es-GT",
        {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        }
    );

}


// =====================================================
// CONVERTIR MONEDA A NÚMERO
// =====================================================

function convertirMonedaANumero(
    valorMoneda
) {

    if (
        valorMoneda === null ||
        valorMoneda === undefined ||
        valorMoneda === ""
    ) {

        return 0;

    }


    let valor =
        String(
            valorMoneda
        )
        .trim();


    valor =
        valor.replace(
            /Q/g,
            ""
        );


    valor =
        valor.replace(
            /\s/g,
            ""
        );


    valor =
        valor.replace(
            /,/g,
            ""
        );


    const resultado =
        Number(
            valor
        );


    return Number.isFinite(
        resultado
    )
        ? resultado
        : 0;

}


// =====================================================
// NÚMERO
// =====================================================

function numero(
    valorNumero
) {

    if (
        valorNumero === null ||
        valorNumero === undefined ||
        valorNumero === ""
    ) {

        return 0;

    }


    const resultado =
        Number(
            String(
                valorNumero
            )
            .replace(
                /,/g,
                ""
            )
        );


    return Number.isFinite(
        resultado
    )
        ? resultado
        : 0;

}


// =====================================================
// VALOR
// =====================================================

function valor(
    dato
) {

    if (
        dato === null ||
        dato === undefined ||
        dato === ""
    ) {

        return "0";

    }


    return escapeHtml(
        String(
            dato
        )
    );

}


// =====================================================
// ESCAPAR HTML
// =====================================================

function escapeHtml(
    texto
) {

    if (
        texto === null ||
        texto === undefined
    ) {

        return "";
    }


    return String(
        texto
    )
    .replace(
        /&/g,
        "&amp;"
    )
    .replace(
        /</g,
        "&lt;"
    )
    .replace(
        />/g,
        "&gt;"
    )
    .replace(
        /"/g,
        "&quot;"
    )
    .replace(
        /'/g,
        "&#039;"
    );

}


// =====================================================
// FUNCIONES GLOBALES
// =====================================================

window.registrosproduccion =
    registrosproduccion;


window.listarProduccion =
    listarProduccion;


window.inicializarProduccion =
    inicializarProduccion;


window.datoPagarProduccion =
    datoPagarProduccion;


window.calcularTotalAPagarProduccion =
    calcularTotalAPagarProduccion;


window.pagarProduccion =
    pagarProduccion;


// =====================================================
// DOM
// =====================================================

document.addEventListener(
    "DOMContentLoaded",
    function () {

        inicializarProduccion();

    }
);